module.exports = __webpack_public_path__ + "img/birds.a65849f6.svg";